import { useCallback, useEffect, useState } from "react";
import { LivePhoto } from "react-native-live-photo";
import { LivePhotoProps } from "react-native-live-photo/src/types";
import { HLS_STREAMING } from "src/api/featureFlags";
import getHlsJs from "src/helpers/videoHelpers/getHlsJs.web";

const PhotoDisplayLivePhotoContentContent = ({ source, ...props }: LivePhotoProps) => {
	const [hlsPromise] = useState(() => getHlsJs());
	const webOverrideVideo = useCallback(
		(video: HTMLVideoElement) => {
			const videoUrl = source.videoUri;
			if (!HLS_STREAMING) return;
			if (!videoUrl) return;
			if (!videoUrl.includes(".m3u8")) return;
			if (!video) return;
			(async () => {
				const Hls = await hlsPromise;
				if (Hls.isSupported()) {
					const hls = new Hls();
					hls.loadSource(videoUrl);
					hls.attachMedia(video);
					/*
			        hls.on(Hls.Events.MANIFEST_PARSED, () => {
			        	video.play();
			        });
                    */
				} else if (video.canPlayType("application/vnd.apple.mpegurl")) {
					video.src = videoUrl;
					/*
			        video.addEventListener("loadedmetadata", () => {
			        	video.play();
			        });
                    */
				}
			})();
		},
		[source, hlsPromise],
	);
	useEffect(() => {
		const videoUrl = source.videoUri;
		if (!HLS_STREAMING) return;
		if (!videoUrl.includes(".m3u8")) return;
		// Prefetching
		fetch(source.videoUri);
	}, [source]);

	return <LivePhoto source={source} webOverrideVideo={webOverrideVideo} {...props} />;
};
export default PhotoDisplayLivePhotoContentContent;
